export default __webpack_public_path__ + "static/media/elan-row.86962f86.png";